<section class="grid gap-4">
  <div class="flex flex-wrap items-center justify-between gap-3">
    <div>
      <page-title [title]="'User management'"></page-title>
    </div>

    <div class="flex gap-2">
      @if (canCreate()) {
        <button matButton="filled" type="button" class="mom-danger" (click)="utils.navigateTo('/user-management/users/new')">
          <mat-icon>person_add</mat-icon>
          Create user
        </button>
      }
    </div>
  </div>

  <user-table
    [users]="userStore.users()"
    [loading]="userStore.loading()"
    [searchTerm]="userStore.usersSearch()"
    [pageNumber]="userStore.usersPageNumber()"
    [pageSize]="userStore.usersPageSize()"
    [totalCount]="userStore.usersTotalCount()"
    [totalPages]="userStore.usersTotalPages()"
    [canDeactivate]="canDeactivate()"
    [canActivate]="canActivate()"
    [actionUserId]="actionUserId()"
    (refreshed)="refresh()"
    (searchChanged)="searchUsers($event)"
    (pageChanged)="changePage($event)"
    (toggled)="toggleUserActive($event)" />
</section>
